/** Visible freeze of Quick VGI / digital scale capture (phase 7C.1). Scoring code remains on disk. */

export const LATAM_SCALE_STEP_ID = 5;
export const VGI_QUICK_SOURCE = "vgi_quick";
export const LATAM_CAPTURE_OMIT_KEYS = ["escalas", "selected_scales", "scale_answers"];

export function nextLatamWorkflowStep(currentStep) {
  const next = Number(currentStep) + 1;
  return next === LATAM_SCALE_STEP_ID ? LATAM_SCALE_STEP_ID + 1 : next;
}

export function previousLatamWorkflowStep(currentStep) {
  const prev = Number(currentStep) - 1;
  return prev === LATAM_SCALE_STEP_ID ? LATAM_SCALE_STEP_ID - 1 : prev;
}

export function resolveLatamWorkflowStep(step) {
  const id = Number(step);
  if (id === LATAM_SCALE_STEP_ID) return LATAM_SCALE_STEP_ID + 1;
  return id;
}

/**
 * LATAM new consultations must never persist digital scale capture or Quick VGI source,
 * even if residual wizard/draft state still holds previous answers.
 */
export function stripLatamCaptureFields(payload) {
  const next = { ...(payload || {}) };
  LATAM_CAPTURE_OMIT_KEYS.forEach((key) => {
    delete next[key];
  });
  if (next.source === VGI_QUICK_SOURCE) delete next.source;
  return next;
}
